var _circle, _path, _rect, _rect2, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIntegrity = function SvgIntegrity(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 80 80"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 28,
    fill: "url(#integrity_svg__a)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m42 49.255-2.03 2.03L28.658 39.97 39.97 28.657 51.284 39.97l-5.53 5.529"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 6,
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    rx: 2,
    transform: "scale(1 -1) rotate(-45 -13.607 -60.163)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 6,
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    rx: 2,
    transform: "scale(1 -1) rotate(-45 -40.163 -49.163)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M45.627 45.627 72 72"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "integrity_svg__a",
    x1: 68.684,
    x2: 11.971,
    y1: 39.135,
    y2: 39.244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00CA72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00CA72",
    stopOpacity: 0.2
  })))));
};
export default SvgIntegrity;